import { useTranslation } from "../../../../../../lib/i18n";
import { useDataTranslation } from "../../../../../../lib/i18n/data";
import { ProfilerProduct } from "../../../../types/ProfilerProduct";

type BeautyProfilerFavoriteFragranceProps = {
  topFetiche: ProfilerProduct | null;
};

export const BeautyProfilerFavoriteFragrance =
  ({ topFetiche }: BeautyProfilerFavoriteFragranceProps) => {
    const { t } = useTranslation();
    const { tData } = useDataTranslation();

    return (
      <>
        <div>
          <p className="text-[#050505] text-center font-garamond-italic text-[20px] italic font-normal">
            {t('results.beauty.favoriteFragrance')}
          </p>
          <h1 className="text-[#CE0A2C] text-center font-bebas-kai text-[40px] font-normal">
            {topFetiche?.label}
          </h1>
        </div>
        <div className="text-[#050505] text-justify font-minion text-[20px] font-normal leading-[150%]">
          {topFetiche ? tData('products', topFetiche.id, 'description', topFetiche.description) : ''}
        </div>
      </>
    );
  };
